/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesListQuery
 */
export interface BookingTolerancesListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingTolerancesListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof BookingTolerancesListQuery
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof BookingTolerancesListQuery
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesListQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof BookingTolerancesListQuery
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof BookingTolerancesListQuery
     */
    carrier?: GuidIdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingTolerancesListQuery
     */
    orderByRelevanceAscending?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BookingTolerancesListQuery
     */
    limit?: number | null;
}

export function BookingTolerancesListQueryFromJSON(json: any): BookingTolerancesListQuery {
    return BookingTolerancesListQueryFromJSONTyped(json, false);
}

export function BookingTolerancesListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdAndLabelFromJSON(json['carrier']),
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByRelevanceAscending': !exists(json, 'orderByRelevanceAscending') ? undefined : json['orderByRelevanceAscending'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function BookingTolerancesListQueryToJSON(value?: BookingTolerancesListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'description': value.description,
        'relevance': value.relevance,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'carrier': GuidIdAndLabelToJSON(value.carrier),
        'showDeleted': value.showDeleted,
        'orderByRelevanceAscending': value.orderByRelevanceAscending,
        'offset': value.offset,
        'limit': value.limit,
    };
}


